export const EnvManager = Object.freeze({
  BACKEND_URL: process.env.REACT_APP_SECURE_STORE_BACKEND_URL,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
});

export default EnvManager;
